/**
 * About.tsx 中 P 对象的文案（与 Lovable /about 一致）
 * 详情大图 URL：Liquid window.AE_DETAIL_IMG（专用大图 webp/jpg，与栅格小图独立）
 */
window.AE_HALLMARK_COPY = {
  'Genomic Instability': {
    title: 'GENOMIC INSTABILITY',
    sub1: 'The Fragmented',
    sub2: 'Blueprint',
    desc:
      'Daily exposure to UV and pollution creates "typos" in your skin\'s DNA. As these errors accumulate, your cells lose the instructions needed to repair themselves, leading to a permanent loss of skin resilience.',
    pills: ['Wrinkles', 'Sagging', 'Dark Spots', 'Fine Lines', 'Skin Cancer'],
  },
  'Telomere Attrition': {
    title: 'TELOMERE ATTRITION',
    sub1: 'The Biological',
    sub2: 'Countdown',
    desc:
      "Telomeres are the protective caps at the ends of your chromosomes. Every time your cells regenerate, these caps get shorter. When they run out, your skin's natural renewal process simply stops, leading to visible aging.",
    pills: ['Thin, Fragile Skin', 'Dullness', 'Roughness'],
  },
  'Epigenetic Alterations': {
    title: 'EPIGENETIC ALTERATIONS',
    sub1: 'The Silent Switches of',
    sub2: 'Biological Aging Clock',
    desc:
      'Lifestyle and environment act as "switches" that turn healthy skin genes off and aging genes on. This shifting genetic landscape dictates the speed of your internal clock, often making skin look older than its chronological years.',
    pills: ['Dark Spots', 'Redness', 'Irritation', 'Roughness'],
  },
  'Loss Of Proteostasis': {
    title: 'LOSS OF PROTEOSTASIS',
    sub1: 'The Protein Crisis of',
    sub2: 'Structural Integrity',
    desc:
      'Your skin relies on a quality-control system to fold and maintain collagen. When this system fails, "misfolded" proteins build up like clutter, causing the skin to lose its firmness and bounce.',
    pills: ['Wrinkles', 'Sagging', 'Dullness'],
  },
  'Disabled Macroautophagy': {
    title: 'DISABLED MACROAUTOPHAGY',
    sub1: 'The Clogged',
    sub2: 'Recycling System',
    desc:
      'Autophagy is your cell\'s internal "janitor". When this process slows down, cellular waste and "junk" build up inside your cells, extinguishing your skin\'s natural clarity and "Lunar Glow".',
    pills: ['Wrinkles', 'Sagging', 'Dullness', 'Dark Spots'],
  },
  'Deregulated Nutrient Sensing': {
    title: 'DEREGULATED NUTRIENT-SENSING',
    sub1: 'The Metabolic',
    sub2: 'Imbalance',
    desc:
      'When cellular nutrient-sensing pathways become deregulated, the resulting metabolic imbalance cripples the skin\'s ability to function. This "Engine Failure" directly reduces self-repair and slows cellular turnover, leading to a visible loss of vitality. Simultaneously, a "Barrier Collapse" occurs as the skin loses its ability to retain moisture and resist irritants. Ultimately, this metabolic decline causes a "Defensive Breakdown," significantly prolonging the skin\'s recovery cycle.',
    pills: ['Fine Lines', 'Dryness', 'Dullness'],
  },
  'Mitochondrial Dysfunction': {
    title: 'MITOCHONDRIAL DYSFUNCTION',
    sub1: 'The Bio-Energy Crisis',
    sub2: 'of the Skin',
    desc:
      'Mitochondria produce ATP, the essential fuel for skin repair and collagen synthesis. Aging triggers a bio-energy crisis where an Energy Deficit starves cells of regenerative power, causing a sallow, "tired" complexion. Simultaneously, damaged mitochondria leak Reactive Oxygen Species (ROS)—toxic "exhaust" that fuels a cycle of oxidative damage. This dual failure collapses the skin\'s structural scaffolding, leaving it thinner, more fragile, and unable to recover from daily stress.',
    pills: ['Dullness', 'Sensitivity', 'Wrinkles'],
  },
  'Cellular Senescence': {
    title: 'CELLULAR SENESCENCE',
    sub1: '"Zombie" Cells:',
    sub2: 'The Toxic Neighbors',
    desc:
      'Senescent "zombies" refuse to die, lingering to secrete a toxic inflammatory cocktail (SASP). This "exhaust" poisons healthy neighbors, forcing premature aging and accelerating collagen breakdown. This "contagious" behavior turns localized stress into widespread sagging, chronic dullness, and persistent inflammation that weakens skin resilience.',
    pills: ['Redness', 'Irritation', 'Sagging', 'Dullness', 'Age Spots'],
  },
  'Stem Cell Exhaustion': {
    title: 'STEM CELL EXHAUSTION',
    sub1: 'The Depleted',
    sub2: 'Reservoir',
    desc:
      'Stem cells are the skin\'s essential backup for tissue renewal. Over time, these reservoirs become depleted, causing the "renewal engine" to stall. Without a fresh supply of cells to reinforce the barrier and dermal matrix, the skin enters a state of permanent atrophy. This loss of regenerative power results in a complexion that is physically thinner, biologically spent,',
    pills: ['Dryness', 'Thin, Fragile Skin', 'Roughness', 'Slow Repair'],
  },
  'Altered Intercellular Communication': {
    title: 'ALTERED INTERCELLULAR COMMUNICATION',
    sub1: 'The Broken Signal',
    sub2: 'of Coordination',
    desc:
      'Skin health depends on a constant, harmonious dialogue between cells. Aging "jams" these communication lines with inflammatory noise, preventing cells from coordinating essential repair and defense tasks.',
    pills: ['Dryness', 'Sensitivity', 'Redness', 'Slow Repair', 'Uneven Tone'],
  },
  'Chronic Inflammation': {
    title: 'INFLAMMAGING',
    sub1: 'The Hidden Fire',
    sub2: 'Beneath Skin Aging',
    desc:
      'Chronic, low-grade inflammation — known as inflammaging — quietly accelerates biological aging. Over time, inflammatory cytokines disrupt collagen integrity, weaken the skin barrier, and trigger visible signs of aging.',
    pills: ['Skin Sensitivity', 'Dryness', 'Acne-Prone', 'Fine Lines', 'Redness', 'Irritation', 'Dark Spots', 'Wrinkles'],
  },
  Dysbiosis: {
    title: 'DYSBIOSIS',
    sub1: 'The Microbiome',
    sub2: 'Disruptor',
    desc:
      'Your skin is home to the microbiome, a living ecosystem of beneficial bacteria that acts as your primary biological shield. Dysbiosis occurs when this balance is disrupted, causing a loss of microbial diversity that triggers inflammation.',
    pills: ['Sensitivity', 'Roughness', 'Acne-Prone'],
  },
  'Extracellular Matrix Changes': {
    title: 'Extracellular Matrix (ECM)  DYSREGULATION',
    sub1: 'The Structural',
    sub2: 'Collapse',
    desc:
      'ECM is the skin\'s biological scaffolding, a 3D mesh of collagen (density), elastin (elasticity), and hyaluronic acid (hydration). Aging accelerates the production of MMPs—enzymes that aggressively chew through these fibers faster than they can be rebuilt. This structural failure causes the skin\'s physical density to collapse.',
    pills: ['Wrinkles', 'Sagging', 'Fine Lines', 'Dryness', 'Thin, Fragile Skin'],
  },
  'Psychosocial Isolation': {
    title: 'THE "MASTER" HALLMARK',
    sub1: 'The Mind-Skin Axis of',
    sub2: 'Biological Aging',
    desc:
      'Science now recognizes that the weakening of social and affective bonds is intrinsically pathogenic. This hallmark reflects a "neglected" driver of aging where social isolation triggers chronic neuroendocrine stress responses. These responses do more than affect our mood; they accelerate organismal decline, leading to compromised biological fitness and disrupted sleep patterns. At Acaderma, we understand that longevity is not just molecular—it is social.',
    pills: [],
  },
};
